var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0067 10.9659C14.8317 11.7909 14.8317 13.1285 14.0067 13.9535C13.1817 14.7785 11.8441 14.7785 11.0191 13.9535C10.1941 13.1285 10.1941 11.7909 11.0191 10.9659C11.8441 10.1409 13.1817 10.1409 14.0067 10.9659",
    stroke: "#307EC5",
    strokeWidth: 1.725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9375 9.59375V16.0625C18.9375 16.856 18.2935 17.5 17.5 17.5H7.4375C6.644 17.5 6 16.856 6 16.0625V9.59375C6 8.80025 6.644 8.15625 7.4375 8.15625H8.875L9.9261 6.3565C10.0549 6.1357 10.2907 6 10.5471 6H14.3594C14.6112 6 14.8446 6.13225 14.9757 6.34845L16.0637 8.15625H17.5012C18.2935 8.15625 18.9375 8.80025 18.9375 9.59375V9.59375Z",
    stroke: "#307EC5",
    strokeWidth: 1.725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.cb7fb590d74770f307ba4fdd1be26a26.svg";
export { ForwardRef as ReactComponent };